import { jsx, jsxs } from "react/jsx-runtime";
const IconHome = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2.09998L1 12H4V21H11V15H13V21H20V12H23L12 2.09998ZM18 19H15V13H9V19H6V10.19L12 4.68998L18 10.19V19Z",
        fill: "currentColor"
      }
    )
  }
);
const IconSidebar = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: Math.round(size * 20 / 24),
    viewBox: "0 0 24 20",
    fill: "none",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.07715 0.0996094H19.9229C20.9788 0.0996279 21.9907 0.504276 22.7363 1.22266C23.4818 1.94096 23.9004 2.91453 23.9004 3.92871V16.0713C23.9004 17.0855 23.4818 18.059 22.7363 18.7773C21.9907 19.4957 20.9788 19.9004 19.9229 19.9004H4.07715C3.0212 19.9004 2.00926 19.4957 1.26367 18.7773C0.518186 18.059 0.0996094 17.0855 0.0996094 16.0713V3.92871C0.0996094 2.91453 0.518186 1.94096 1.26367 1.22266C2.00926 0.504276 3.0212 0.0996276 4.07715 0.0996094ZM4.07715 2.04297C3.56031 2.04299 3.06382 2.24056 2.69727 2.59375C2.33057 2.94708 2.12402 3.42736 2.12402 3.92871V16.0713C2.12402 16.5726 2.33057 17.0529 2.69727 17.4062C3.06382 17.7594 3.56031 17.957 4.07715 17.957H6.03027V2.04297H4.07715ZM8.05469 17.957H19.9229C20.4397 17.957 20.9362 17.7594 21.3027 17.4062C21.6694 17.0529 21.876 16.5726 21.876 16.0713V3.92871C21.876 3.42736 21.6694 2.94708 21.3027 2.59375C20.9362 2.24056 20.4397 2.04299 19.9229 2.04297H8.05469V17.957Z",
        fill: "currentColor"
      }
    )
  }
);
const IconCompose = ({ size = 20, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.95216 19.6877C5.99369 19.6794 6.03672 19.6865 6.07357 19.7074C7.55917 20.5512 9.24531 21 11 21C13.4663 21 15.7971 20.1133 17.6265 18.4899C17.7783 18.3552 17.9265 18.2154 18.071 18.071C19.96 16.1824 21 13.6713 21 11C21 8.32909 19.96 5.81806 18.071 3.92901C16.1966 2.05461 13.6654 1.00374 11.0146 1.00001C8.33826 0.996234 5.821 2.03706 3.92905 3.92901C3.78461 4.07349 3.64481 4.22167 3.51012 4.37358C1.88672 6.20337 1 8.53366 1 11C1 12.8347 1.49071 14.5937 2.41 16.1274C2.43403 16.1675 2.44137 16.2153 2.43 16.2606L1.60577 19.5527C1.54751 19.7857 1.61324 20.0322 1.77909 20.206C1.91237 20.3449 2.10817 20.4713 2.45494 20.3876L5.95216 19.6877Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M8.44141 11.0098H13.5451", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M11.0039 8.44531V13.549", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconImageUpload = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.342 23.9893H8.64729C2.58861 23.9893 0 21.4007 0 15.342V8.64729C0 2.58861 2.58861 0 8.64729 0H15.342C21.4007 0 23.9893 2.58861 23.9893 8.64729V15.342C23.9893 21.4007 21.4007 23.9893 15.342 23.9893ZM8.64729 1.67367C3.50355 1.67367 1.67367 3.50355 1.67367 8.64729V15.342C1.67367 20.4857 3.50355 22.3156 8.64729 22.3156H15.342C20.4857 22.3156 22.3156 20.4857 22.3156 15.342V8.64729C22.3156 3.50355 20.4857 1.67367 15.342 1.67367H8.64729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.64728 10.5999C6.9513 10.5999 5.57889 9.2275 5.57889 7.53151C5.57889 5.83553 6.9513 4.46312 8.64728 4.46312C10.3433 4.46312 11.7157 5.83553 11.7157 7.53151C11.7157 9.2275 10.3433 10.5999 8.64728 10.5999ZM8.64728 6.13679C7.8774 6.13679 7.25256 6.76162 7.25256 7.53151C7.25256 8.3014 7.8774 8.92624 8.64728 8.92624C9.41717 8.92624 10.042 8.3014 10.042 7.53151C10.042 6.76162 9.41717 6.13679 8.64728 6.13679Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.58414 20.5863C1.31636 20.5863 1.04857 20.4524 0.892361 20.218C0.635731 19.8387 0.736151 19.3143 1.12667 19.0576L6.62747 15.3644C7.83251 14.5499 9.49502 14.6503 10.5885 15.5764L10.9567 15.9C11.5146 16.3798 12.463 16.3798 13.0098 15.9L17.6514 11.9166C18.8341 10.9013 20.6975 10.9013 21.8914 11.9166L23.7101 13.4787C24.056 13.78 24.1006 14.3044 23.7994 14.6615C23.4981 15.0074 22.9737 15.052 22.6166 14.7507L20.7979 13.1886C20.24 12.7088 19.2916 12.7088 18.7337 13.1886L14.0921 17.172C12.9093 18.1873 11.046 18.1873 9.85211 17.172L9.48387 16.8484C8.97061 16.4132 8.12261 16.3686 7.55357 16.7591L2.05277 20.4524C1.90772 20.5416 1.74035 20.5863 1.58414 20.5863Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconMicrophone = ({
  size = 17,
  height = 24,
  className,
  style
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.5 17.1429C5.68778 17.1429 3.4 14.8359 3.4 12V5.14286C3.4 2.307 5.68778 0 8.5 0C11.3122 0 13.6 2.307 13.6 5.14286V12C13.6 14.8359 11.3122 17.1429 8.5 17.1429ZM8.5 1.71429C6.62533 1.71429 5.1 3.25243 5.1 5.14286V12C5.1 13.8904 6.62533 15.4286 8.5 15.4286C10.3747 15.4286 11.9 13.8904 11.9 12V5.14286C11.9 3.25243 10.3747 1.71429 8.5 1.71429ZM16.15 10.2857C15.6806 10.2857 15.3 10.6695 15.3 11.1429V12C15.3 15.7811 12.2496 18.8571 8.5 18.8571C4.75044 18.8571 1.7 15.7811 1.7 12V11.1429C1.7 10.6695 1.31941 10.2857 0.85 10.2857C0.380587 10.2857 0 10.6695 0 11.1429V12C0 16.4372 3.36069 20.0966 7.65 20.5279V22.2857H5.95C5.48059 22.2857 5.1 22.6695 5.1 23.1429C5.1 23.6162 5.48059 24 5.95 24H11.05C11.5194 24 11.9 23.6162 11.9 23.1429C11.9 22.6695 11.5194 22.2857 11.05 22.2857H9.35V20.5279C13.6393 20.0964 17 16.437 17 12V11.1429C17 10.6695 16.6194 10.2857 16.15 10.2857Z",
        fill: "currentColor"
      }
    )
  }
);
const IconArrowRight = ({ size = 12, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size * 9 / 12,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1231 4.03711C11.1229 4.03695 11.1228 4.03675 11.1226 4.03659L8.22563 1.16103C8.0086 0.945614 7.65757 0.946414 7.44154 1.1629C7.22553 1.37938 7.22637 1.72952 7.44339 1.94495L9.38841 3.87559H1.55442C1.24822 3.87559 1 4.12315 1 4.42858C1 4.734 1.24822 4.98161 1.55442 4.98161H9.38839L7.44344 6.9122C7.22641 7.12765 7.22557 7.47776 7.44158 7.69423C7.6576 7.91075 8.00867 7.91151 8.22567 7.69612L11.1226 4.82053C11.1228 4.82037 11.1229 4.82017 11.1231 4.82C11.3403 4.60386 11.3396 4.25257 11.1231 4.03712L11.1231 4.03711Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.428571"
      }
    )
  }
);
const IconHamburger = ({ size = 32, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 10h12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 16h20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 22h16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconChats = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2796 16.1373L19.118 12.7029C19.6779 11.5401 19.9738 10.2468 19.9758 8.94564C19.9792 6.68311 19.1176 4.54385 17.5495 2.92195C15.9812 1.29973 13.8912 0.386554 11.6647 0.35072C9.35587 0.313654 7.18572 1.20584 5.55419 2.86329C3.98099 4.4615 3.10841 6.56846 3.08079 8.81999C1.53024 10.006 0.615044 11.8551 0.618052 13.8301C0.619497 14.7544 0.824263 15.6731 1.21227 16.5039L0.412153 18.8694C0.274614 19.2761 0.375083 19.7176 0.67438 20.0217C0.885006 20.2357 1.1627 20.3496 1.44829 20.3496C1.56844 20.3496 1.69001 20.3295 1.80856 20.2881L4.13704 19.4752C4.95481 19.8694 5.85915 20.0774 6.76892 20.0789C6.7722 20.0789 6.77532 20.0789 6.77861 20.0789C8.75165 20.0788 10.5856 19.1251 11.7488 17.5112C12.9592 17.4788 14.1569 17.1812 15.2396 16.6431L18.6202 17.8232C18.761 17.8724 18.9055 17.8964 19.0483 17.8964C19.3876 17.8964 19.7176 17.761 19.968 17.5066C20.3236 17.1453 20.443 16.6206 20.2796 16.1373ZM6.77853 18.8695C6.77599 18.8695 6.77329 18.8695 6.77075 18.8695C5.96552 18.8682 5.16587 18.6666 4.45841 18.2863C4.31294 18.2082 4.14216 18.1946 3.98661 18.2489L1.59899 19.0824L2.41942 16.6568C2.47286 16.4988 2.45958 16.3253 2.38262 16.1775C2.00833 15.4588 1.80981 14.6464 1.80856 13.8283C1.80657 12.5124 2.31044 11.2652 3.19157 10.3313C3.47938 12.1137 4.3156 13.7563 5.61177 15.0496C6.89837 16.3335 8.51564 17.1509 10.2606 17.4181C9.33923 18.3407 8.0972 18.8695 6.77853 18.8695ZM19.1261 16.6514C19.0923 16.6858 19.0521 16.6952 19.0069 16.6794L15.3879 15.416C15.325 15.394 15.2596 15.3832 15.1945 15.3832C15.0984 15.3832 15.0027 15.4068 14.9161 15.4534C13.8828 16.0087 12.7151 16.3032 11.5393 16.3051C11.5354 16.3051 11.5319 16.3051 11.528 16.3051C7.58806 16.3051 4.33364 13.0536 4.27122 9.05183C4.23978 7.03646 4.99439 5.14237 6.39599 3.71845C7.79759 2.29454 9.66232 1.52819 11.6458 1.55994C15.5887 1.62348 18.7914 4.93581 18.7853 8.94373C18.7835 10.1383 18.4936 11.3246 17.947 12.3743C17.87 12.522 17.8567 12.6955 17.9102 12.8536L19.1537 16.5303C19.1692 16.5763 19.1599 16.6171 19.1261 16.6514Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.7"
      }
    )
  }
);
const IconChevronUp = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18 15l-6-6-6 6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const IconClose = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx("path", { d: "M15.5 4.5L4.5 15.5M4.5 4.5l11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  }
);
const IconSearch = ({ size = 16, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.8178 14.9381L11.913 11.0334C12.8836 9.86621 13.4683 8.36744 13.4683 6.73438C13.4683 3.02103 10.4474 0 6.73421 0C3.02094 0 0 3.02103 0 6.73438C0 10.4475 3.02094 13.4683 6.73421 13.4683C8.36719 13.4683 9.86605 12.8836 11.0332 11.913L14.9381 15.8178C15.0595 15.9393 15.2188 16 15.3779 16C15.5371 16 15.6963 15.9393 15.8179 15.8178C16.0608 15.5748 16.0608 15.181 15.8178 14.9381ZM1.24414 6.73438C1.24414 3.70705 3.70696 1.24414 6.73421 1.24414C9.76137 1.24414 12.2241 3.70705 12.2241 6.73438C12.2241 9.76146 9.76137 12.2241 6.73421 12.2241C3.70696 12.2241 1.24414 9.76146 1.24414 6.73438Z",
        fill: "currentColor"
      }
    )
  }
);
const IconTrash = ({ size = 18, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size * 15.1 / 12.1,
    viewBox: "0 0 12.1 15.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.44965 4.66556C1.77024 4.67332 2.0238 4.93783 2.01598 5.25636L1.43551 5.24231C0.855035 5.22826 0.855035 5.22826 0.855035 5.22826L0.854262 5.26106L0.85217 5.35429C0.850407 5.43533 0.84797 5.55294 0.845255 5.69963C0.83984 5.99297 0.833345 6.40288 0.82901 6.86938C0.82037 7.79975 0.820235 8.96488 0.855282 9.87965C0.89363 10.8802 0.996852 12.1752 1.08202 13.1395C1.17822 14.2286 2.09883 15.05 3.19023 15.05H8.90975C10.0011 15.05 10.9218 14.2286 11.018 13.1395C11.1031 12.1752 11.2064 10.8802 11.2447 9.87965C11.2797 8.96488 11.2796 7.79975 11.271 6.86938C11.2666 6.40288 11.2602 5.99297 11.2548 5.69963C11.252 5.55294 11.2496 5.43533 11.2478 5.35429L11.2458 5.26106L11.2449 5.22887C11.2371 4.91033 10.9709 4.6578 10.6503 4.66556C10.3297 4.67332 10.0762 4.93783 10.084 5.25636L10.0848 5.28766L10.0868 5.37924C10.0885 5.45915 10.091 5.57549 10.0936 5.7208C10.099 6.01147 10.1055 6.41773 10.1097 6.88003C10.1184 7.80703 10.1182 8.94958 10.0842 9.83578C10.0471 10.8059 9.9461 12.0769 9.86112 13.0387C9.81837 13.5231 9.40805 13.8961 8.90975 13.8961H3.19023C2.69193 13.8961 2.28165 13.5231 2.23887 13.0387C2.15391 12.0769 2.05291 10.8059 2.01573 9.83578C1.98177 8.94958 1.98164 7.80703 1.99025 6.88003C1.99455 6.41773 2.00099 6.01147 2.00635 5.7208C2.00904 5.57549 2.01145 5.45915 2.01319 5.37924L2.01524 5.28766L2.01598 5.25636L1.43551 5.24231Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.05 2.93461C0.05 2.61599 0.309965 2.35769 0.630642 2.35769H11.4693C11.79 2.35769 12.05 2.61599 12.05 2.93461C12.05 3.25324 11.79 3.51154 11.4693 3.51154H0.630642C0.309965 3.51154 0.05 3.25324 0.05 2.93461Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.24241 1.16991C3.61243 0.480583 4.33469 0.05 5.12098 0.05H6.97903C7.76533 0.05 8.48757 0.480583 8.85762 1.16991L9.65907 2.66312C9.81005 2.94426 9.70295 3.29373 9.42005 3.44367C9.13708 3.59361 8.78533 3.48725 8.63443 3.20611L7.8329 1.71289C7.66475 1.39956 7.3364 1.20385 6.97903 1.20385H5.12098C4.7636 1.20385 4.43527 1.39956 4.26708 1.71289L3.46556 3.20611C3.31465 3.48725 2.96293 3.59361 2.67998 3.44367C2.39703 3.29373 2.28998 2.94426 2.4409 2.66312L3.24241 1.16991Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconShareChat = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { transform: "rotate(-90deg)", ...style },
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.4801 16.0183C19.4801 17.3982 18.3571 18.5212 16.9771 18.5212C15.5974 18.5209 14.4752 17.3981 14.4752 16.0183C14.4752 15.3095 14.7729 14.6701 15.2477 14.2145L12.8443 10.3347C12.5803 10.4298 12.2962 10.4841 11.9996 10.4841C11.7037 10.484 11.4206 10.4296 11.1568 10.3347L8.75352 14.2145C9.22794 14.6701 9.525 15.3097 9.525 16.0183C9.525 17.3982 8.40204 18.5212 7.02207 18.5212C5.64235 18.521 4.52012 17.3981 4.52012 16.0183C4.52012 14.6384 5.64235 13.5155 7.02207 13.5153C7.3186 13.5153 7.60272 13.5697 7.8668 13.6647L10.2701 9.78486C9.79549 9.32937 9.49776 8.69063 9.49766 7.98212C9.49766 6.60228 10.6198 5.4794 11.9996 5.47919C13.3795 5.47919 14.5025 6.60215 14.5025 7.98212C14.5024 8.69034 14.2052 9.32941 13.7311 9.78486L16.1344 13.6647C16.398 13.57 16.6812 13.5154 16.9771 13.5153C18.3571 13.5153 19.4801 14.6383 19.4801 16.0183ZM8.48203 16.0183C8.48203 15.2138 7.82656 14.5593 7.02207 14.5593C6.21777 14.5595 5.56309 15.2139 5.56309 16.0183C5.56309 16.8226 6.21777 17.477 7.02207 17.4772C7.82656 17.4772 8.48203 16.8227 8.48203 16.0183ZM13.4596 7.98212C13.4596 7.17752 12.8041 6.52216 11.9996 6.52216C11.1953 6.52237 10.5406 7.17765 10.5406 7.98212C10.5408 8.7863 11.1954 9.44089 11.9996 9.44111C12.804 9.44111 13.4594 8.78643 13.4596 7.98212ZM18.4371 16.0183C18.4371 15.2138 17.7816 14.5593 16.9771 14.5593C16.1728 14.5595 15.5182 15.2139 15.5182 16.0183C15.5182 16.8226 16.1728 17.477 16.9771 17.4772C17.7816 17.4772 18.4371 16.8227 18.4371 16.0183Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.16"
      }
    )
  }
);
const IconRenameChat = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.9366 5.55017L18.441 5.05459C17.6942 4.30773 16.4727 4.30773 15.7258 5.05459L8.52943 12.2649C8.32701 12.4673 8.20137 12.7326 8.17345 13.0188L7.985 15.0639C7.96406 15.3222 8.0548 15.5734 8.23627 15.7619C8.40379 15.9294 8.62017 16.0202 8.85051 16.0202H8.92729L10.9724 15.8317C11.2586 15.8038 11.5239 15.6781 11.7263 15.4757L18.9296 8.27237C19.2926 7.90941 19.495 7.42779 19.495 6.91825C19.495 6.40871 19.2926 5.92011 18.9296 5.56413L18.9366 5.55017ZM10.9934 14.7289C10.9934 14.7289 10.9236 14.7777 10.8887 14.7777L9.05293 14.9452L9.22045 13.1095C9.22045 13.0676 9.24139 13.0327 9.26931 12.9978L15.1185 7.14859L16.8426 8.87265L10.9934 14.7219V14.7289ZM18.1967 7.52551L17.5825 8.13975L15.8584 6.41569L16.4727 5.80145C16.6402 5.63393 16.8635 5.54319 17.0869 5.54319C17.3103 5.54319 17.5336 5.62695 17.7011 5.80145L18.1967 6.29703C18.3642 6.46455 18.455 6.68093 18.455 6.91127C18.455 7.14161 18.3642 7.36497 18.1967 7.52551ZM18.106 12.8303V16.8857C18.106 18.3305 16.9333 19.5032 15.4885 19.5032H7.1125C5.66764 19.5032 4.495 18.3305 4.495 16.8857V8.50969C4.495 7.06483 5.66764 5.89219 7.1125 5.89219H11.1679C11.4541 5.89219 11.6914 6.12951 11.6914 6.41569C11.6914 6.70187 11.4541 6.93919 11.1679 6.93919H7.1125C6.24698 6.93919 5.542 7.64417 5.542 8.50969V16.8857C5.542 17.7512 6.24698 18.4562 7.1125 18.4562H15.4885C16.354 18.4562 17.059 17.7512 17.059 16.8857V12.8303C17.059 12.5441 17.2963 12.3068 17.5825 12.3068C17.8687 12.3068 18.106 12.5441 18.106 12.8303Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.2"
      }
    )
  }
);
const IconDeleteChat = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsxs("g", { transform: "translate(5.95 4.45)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.44965 4.66556C1.77024 4.67332 2.0238 4.93783 2.01598 5.25636L1.43551 5.24231C0.855035 5.22826 0.855035 5.22826 0.855035 5.22826L0.854262 5.26106L0.85217 5.35429C0.850407 5.43533 0.84797 5.55294 0.845255 5.69963C0.83984 5.99297 0.833345 6.40288 0.82901 6.86938C0.82037 7.79975 0.820235 8.96488 0.855282 9.87965C0.89363 10.8802 0.996852 12.1752 1.08202 13.1395C1.17822 14.2286 2.09883 15.05 3.19023 15.05H8.90975C10.0011 15.05 10.9218 14.2286 11.018 13.1395C11.1031 12.1752 11.2064 10.8802 11.2447 9.87965C11.2797 8.96488 11.2796 7.79975 11.271 6.86938C11.2666 6.40288 11.2602 5.99297 11.2548 5.69963C11.252 5.55294 11.2496 5.43533 11.2478 5.35429L11.2458 5.26106L11.2449 5.22887C11.2371 4.91033 10.9709 4.6578 10.6503 4.66556C10.3297 4.67332 10.0762 4.93783 10.084 5.25636L10.0848 5.28766L10.0868 5.37924C10.0885 5.45915 10.091 5.57549 10.0936 5.7208C10.099 6.01147 10.1055 6.41773 10.1097 6.88003C10.1184 7.80703 10.1182 8.94958 10.0842 9.83578C10.0471 10.8059 9.9461 12.0769 9.86112 13.0387C9.81837 13.5231 9.40805 13.8961 8.90975 13.8961H3.19023C2.69193 13.8961 2.28165 13.5231 2.23887 13.0387C2.15391 12.0769 2.05291 10.8059 2.01573 9.83578C1.98177 8.94958 1.98164 7.80703 1.99025 6.88003C1.99455 6.41773 2.00099 6.01147 2.00635 5.7208C2.00904 5.57549 2.01145 5.45915 2.01319 5.37924L2.01524 5.28766L2.01598 5.25636L1.43551 5.24231Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.05 2.93461C0.05 2.61599 0.309965 2.35769 0.630642 2.35769H11.4693C11.79 2.35769 12.05 2.61599 12.05 2.93461C12.05 3.25324 11.79 3.51154 11.4693 3.51154H0.630642C0.309965 3.51154 0.05 3.25324 0.05 2.93461Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.24241 1.16991C3.61243 0.480583 4.33469 0.05 5.12098 0.05H6.97903C7.76533 0.05 8.48757 0.480583 8.85762 1.16991L9.65907 2.66312C9.81005 2.94426 9.70295 3.29373 9.42005 3.44367C9.13708 3.59361 8.78533 3.48725 8.63443 3.20611L7.8329 1.71289C7.66475 1.39956 7.3364 1.20385 6.97903 1.20385H5.12098C4.7636 1.20385 4.43527 1.39956 4.26708 1.71289L3.46556 3.20611C3.31465 3.48725 2.96293 3.59361 2.67998 3.44367C2.39703 3.29373 2.28998 2.94426 2.4409 2.66312L3.24241 1.16991Z",
          fill: "currentColor"
        }
      )
    ] })
  }
);
export {
  IconArrowRight,
  IconChats,
  IconChevronUp,
  IconClose,
  IconCompose,
  IconDeleteChat,
  IconHamburger,
  IconHome,
  IconImageUpload,
  IconMicrophone,
  IconRenameChat,
  IconSearch,
  IconShareChat,
  IconSidebar,
  IconTrash
};
//# sourceMappingURL=ConciergeIcons.js.map
